import React from "react";
import { Redirect, useParams } from "react-router-dom";
import useData from "../../Hooks/useData";

const ServiceRedirect = () => {
  const { servId } = useParams();
  const services = useData();
  const service = services.find((s) => s.id === Number(servId));

  if (services.length === 0) {
    return null;
  }

  if (!service) {
    return <Redirect to="/services" />;
  }

  return <Redirect to={`/explore/${service.slug}`} />;
};

export default ServiceRedirect;
